import { isDateValid } from "../modules/definition/calendar/dateFunctions";

const canLimitDateRangeToItems = ({ dateFrom, dateTo, timelineContentRange }) => {
  // If range.from exists, range.to will also exist
  return (!isDateValid(dateFrom) || !isDateValid(dateTo)) && isDateValid(timelineContentRange.to);
};

const getOnLimitDateRangeToItems = ({ dateFrom, dateTo, timelineContentRange, onDateFromChange, onDateToChange }) => {
  return () => {
    if (!isDateValid(dateFrom)) {
      onDateFromChange(timelineContentRange.from);
    }
    if (!isDateValid(dateTo)) {
      onDateToChange(timelineContentRange.to);
    }
  };
};

const getOnExtendRangeToItems = ({
  eventsOutOfRangeNumber,
  timelineContentRange,
  onDateFromChange,
  onDateToChange
}) => {
  return () => {
    if (eventsOutOfRangeNumber.left > 0) {
      onDateFromChange(timelineContentRange.from);
    }
    if (eventsOutOfRangeNumber.right > 0) {
      onDateToChange(timelineContentRange.to);
    }
  };
};

export { canLimitDateRangeToItems, getOnExtendRangeToItems, getOnLimitDateRangeToItems };
